import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const login_history = apiUrl + "/login_history";
const routes = {
  label: "Login History",
  root: login_history,
  get_all: login_history + "/get_all",
  get_filtered: login_history + "/get_filtered",
  get_analytics: login_history + "/get_analytics",
  get_organizations: login_history + "/get_organizations",
  get_users_by_org: login_history + "/get_users_by_org",
};

export const LoginHistory = {
  get_all: () => postWithToken(routes.get_all),
  get_filtered: (filters) => postWithToken(routes.get_filtered, filters),
  get_analytics: (params) => postWithToken(routes.get_analytics, params),
  get_organizations: () => postWithToken(routes.get_organizations),
  get_users_by_org: (company_id) => postWithToken(routes.get_users_by_org, { company_id }),
};
